// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailPage_TradeFragmentDoc } from '../../components/AddTradePartnerModal.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UploadBidModalQueryVariables = Types.Exact<{
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  markets?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type UploadBidModalQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> };


export const UploadBidModalDocument = gql`
    query UploadBidModal($costCodes: [ID!]!, $markets: [ID!]) {
  tradePartners(filter: {coversCostCodes: $costCodes, markets: $markets}) {
    ...BidPackageDetailPage_Trade
  }
}
    ${BidPackageDetailPage_TradeFragmentDoc}`;

/**
 * __useUploadBidModalQuery__
 *
 * To run a query within a React component, call `useUploadBidModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadBidModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadBidModalQuery({
 *   variables: {
 *      costCodes: // value for 'costCodes'
 *      markets: // value for 'markets'
 *   },
 * });
 */
export function useUploadBidModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UploadBidModalQuery, UploadBidModalQueryVariables> & ({ variables: UploadBidModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UploadBidModalQuery, UploadBidModalQueryVariables>(UploadBidModalDocument, options);
      }
export function useUploadBidModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UploadBidModalQuery, UploadBidModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UploadBidModalQuery, UploadBidModalQueryVariables>(UploadBidModalDocument, options);
        }
// @ts-ignore
export function useUploadBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UploadBidModalQuery, UploadBidModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadBidModalQuery, UploadBidModalQueryVariables>;
export function useUploadBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadBidModalQuery, UploadBidModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadBidModalQuery | undefined, UploadBidModalQueryVariables>;
export function useUploadBidModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadBidModalQuery, UploadBidModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UploadBidModalQuery, UploadBidModalQueryVariables>(UploadBidModalDocument, options);
        }
export type UploadBidModalQueryHookResult = ReturnType<typeof useUploadBidModalQuery>;
export type UploadBidModalLazyQueryHookResult = ReturnType<typeof useUploadBidModalLazyQuery>;
export type UploadBidModalSuspenseQueryHookResult = ReturnType<typeof useUploadBidModalSuspenseQuery>;
export type UploadBidModalQueryResult = ApolloReactCommon.QueryResult<UploadBidModalQuery, UploadBidModalQueryVariables>;